"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _GeoJSON = _interopRequireDefault(require("ol/format/GeoJSON"));

var _Vector = _interopRequireDefault(require("ol/layer/Vector"));

var _Vector2 = _interopRequireDefault(require("ol/source/Vector"));

var _createLayer = _interopRequireDefault(require("./createLayer"));

var _propTypes = require("prop-types");

var VectorLayer = (0, _createLayer["default"])({
  displayName: 'VectorLayer',
  propTypes: {
    data: _propTypes.object,
    layerStyle: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.object, _propTypes.func]),
    url: _propTypes.string
  },
  componentDidMount: function componentDidMount() {
    this.createFormat();
    var source = new _Vector2["default"]();

    if (this.props.data) {
      var features = this.format.readFeatures(this.props.data);
      source = new _Vector2["default"]({
        features: features
      });
    } else if (this.props.url) {
      source = new _Vector2["default"]({
        url: this.props.url,
        format: this.format
      });
    }

    this.layer = new _Vector["default"]({
      source: source,
      style: this.props.layerStyle,
      visible: this.props.visible
    });
  },
  componentDidUpdate: function componentDidUpdate(prevProps) {
    // Check the projection
    var projChanged = this.checkProjections(); // Create a new format if projection changed

    if (projChanged) {
      this.createFormat();
    } // If data or projection changed


    if (this.props.data !== prevProps.data || this.props.data && projChanged) {
      var source = this.layer.getSource();
      source.clear();

      if (this.props.data) {
        source.addFeatures(this.format.readFeatures(this.props.data));
      }
    } // If url or projection changed


    if (this.props.url !== prevProps.url || this.props.url && projChanged) {
      if (this.props.url) {
        this.layer.setSource(new _Vector2["default"]({
          url: this.props.url,
          format: this.format
        }));
      } else {
        this.layer.getSource().clear();
      }
    } // If the style changed


    if (this.props.layerStyle !== prevProps.layerStyle) {
      this.layer.setStyle(this.props.layerStyle);
    }
  },
  // Check current format feature projection vs current map projection
  checkProjections: function checkProjections() {
    return this.format.defaultFeatureProjection.getCode() !== this.context.map.getView().getProjection().getCode();
  },
  // Create a GeoJSON format using the map's projection
  createFormat: function createFormat() {
    this.format = new _GeoJSON["default"]({
      featureProjection: this.context.map.getView().getProjection()
    });
  }
});
var _default = VectorLayer;
exports["default"] = _default;